<ng-template #itemTemplate let-item>
  {{ item.number }}
  @if (item.name) {
    <span> - {{ item.name }}</span>
  }
</ng-template>
<ng-template #selectedItemTemplate let-item>
  {{ item.number }}
</ng-template>
